// Copyright © Veeam Software Group GmbH
/* eslint-disable */
// Autogenerated

export enum RepositoryCleanerScheduleType {
    Daily = 0,
    Monthly = 1
}
